export default function PartnerCardSkeleton() {
  return (
    <div className="rounded-xl border border-white/[0.04] bg-gray-4 p-3.5 flex items-center gap-3">
      <div className="w-12 h-12 rounded-xl skeleton shrink-0" />
      <div className="flex-1 space-y-1.5">
        <div className="w-32 h-3.5 skeleton rounded" />
        <div className="w-20 h-2.5 skeleton rounded" />
      </div>
      <div className="w-5 h-5 skeleton rounded shrink-0" />
    </div>
  );
}
